/* =========================================================
 * main.js
 * =======================================================*/

/* ------------------------ Slick ------------------------ */
function initSlick() {
	const slickCarousel = document.querySelectorAll('.js-slick');
	if (!slickCarousel.length) return;
	if (!(window.$ && $.fn && $.fn.slick)) return;

	slickCarousel.forEach((element) => {
		$(element).slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 500
		});
	});
}

/* ------------------------ Cookies buttons ------------------------ */
function initCookieButtons() {
	const acceptBtn = document.querySelector('.section-cookies .btn-accept');
	const declineBtn = document.querySelector('.section-cookies .btn-decline');

	if (acceptBtn) {
		acceptBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!(window.$ && $.ajax)) return;

			$.ajax({
				method: "POST",
				url: "api/cookies/",
				data: { 'cookies-accepted': 1 }
			}).done(function () {
				$('.section-cookies').addClass('mod-hide').removeClass('show');
			});
		});
	}

	if (declineBtn) {
		declineBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!(window.$ && $.ajax)) return;

			$.ajax({
				method: "POST",
				url: "api/cookies/",
				data: { 'cookies-accepted': 0 }
			}).done(function () {
				$('.section-cookies').addClass('mod-hide').removeClass('show');
			});
		});
	}
}

/* ------------------------ Form field effects ------------------------ */
function initFormFieldEffects() {
	document.querySelectorAll('form input, form textarea').forEach((el) => {
		el.addEventListener('focus', () => {
			el.parentElement && el.parentElement.classList.add('mod-filled');
		});
		el.addEventListener('blur', () => {
			if (!el.parentElement) return;
			if (el.value) el.parentElement.classList.add('mod-filled');
			else el.parentElement.classList.remove('mod-filled');
		});
	});
}

/* ------------------------ Contact form + reCAPTCHA ------------------------ */
function initContactForm() {
	const contactPage = document.querySelector('#contact');
	const contactForm = document.querySelector('#contactForm');
	if (!(contactPage && contactForm)) return;

	// Refresh token every 90 seconds (only if grecaptcha available)
	if (window.grecaptcha) {
		setInterval(() => {
			grecaptcha.ready(function () {
				grecaptcha.execute('6LcRhcQrAAAAALZP-mkxTK8rDFTge8yROigYvRUF', { action: 'submit' }).then(function (token) {
					let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
					if (!tokenField) {
						tokenField = document.createElement('input');
						tokenField.type = 'hidden';
						tokenField.name = 'g-recaptcha-response';
						contactForm.appendChild(tokenField);
					}
					tokenField.value = token;
				});
			});
		}, 90000);
	}

	contactForm.addEventListener('submit', function (event) {
		event.preventDefault();
		const spamField = document.querySelector('input#Form_Email');
		const loadingSpinner = document.querySelector('.section-form .loading');
		if (spamField && spamField.value) return false;
		if (loadingSpinner) loadingSpinner.classList.add('mod-show');

		// Generate token then submit via AJAX
		if (!window.grecaptcha || !(window.$ && $.ajax)) return;

		grecaptcha.ready(function () {
			grecaptcha.execute('6LcRhcQrAAAAALZP-mkxTK8rDFTge8yROigYvRUF', { action: 'submit' }).then(function (token) {
				let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
				if (!tokenField) {
					tokenField = document.createElement('input');
					tokenField.type = 'hidden';
					tokenField.name = 'g-recaptcha-response';
					contactForm.appendChild(tokenField);
				}
				tokenField.value = token;

				$.ajax({
					method: 'POST',
					url: 'process/contact/',
					dataType: 'json',
					data: $(contactForm).serialize()
				}).done(function (response) {
					if (response == 'success') {
						if (loadingSpinner) loadingSpinner.classList.remove('mod-show');

						document.querySelectorAll('#contactForm .form-element').forEach((el) => {
							el.classList.remove('mod-filled');
						});

						contactForm.classList.add('mod-hide');
						if (contactForm.nextElementSibling) contactForm.nextElementSibling.classList.add('mod-show');
						contactForm.firstElementChild && contactForm.firstElementChild.nextElementSibling && (contactForm.firstElementChild.nextElementSibling.innerHTML = '');

						document.querySelectorAll('#contactForm .form-element input, #contactForm .form-element textarea').forEach((el) => { el.value = ''; });
						document.querySelectorAll('#contact .sub-error').forEach((el) => { el.innerHTML = ''; });
						document.querySelectorAll('#contactForm .form-element').forEach((el) => { el.classList.remove('mod-error'); });

						setTimeout(function () {
							contactForm.classList.remove('mod-hide');
							if (contactForm.nextElementSibling) contactForm.nextElementSibling.classList.remove('mod-show');
						}, 10000);
					} else {
						if (loadingSpinner) loadingSpinner.classList.remove('mod-show');
						contactForm.firstElementChild && contactForm.firstElementChild.nextElementSibling && (contactForm.firstElementChild.nextElementSibling.innerHTML = 'Please fix the errors below:');

						document.querySelectorAll('#contactForm .sub-error').forEach((el) => { el.innerHTML = ''; });
						document.querySelectorAll('#contactForm .form-element').forEach((el) => { el.classList.remove('mod-error'); });

						for (const [key, value] of Object.entries(response)) {
							if (!key) continue;
							const errorEl = document.querySelector('#contactForm .sub-error[data-error="' + key + '"]');
							if (errorEl) errorEl.innerHTML = value['message'];
							if (key !== 'recaptcha') {
								const formEl = document.querySelector('#contactForm .form-element.mod-' + key);
								if (formEl) formEl.classList.add('mod-error');
							}
						}
					}
				});
			});
		});
	});
}


/* ------------------------ Mobile nav / hamburger ------------------------ */
function initNavHamburger() {
	const nav = document.querySelector('#nav');
	const header = document.querySelector('.header-main');
	if (!nav || !header) return;

	const body = document.body;

	document.addEventListener('click', (e) => {
		const btn = e.target.closest('.mob-hamburger');
		if (!btn) return;

		e.preventDefault();

		const isActive = header.classList.toggle('mod-active');
		nav.classList.toggle('mod-show');
		body.classList.toggle('no-scroll');

		// Sync all hamburger buttons
		document.querySelectorAll('.mob-hamburger').forEach((hb) => {
			hb.classList.toggle('mod-active', isActive);
			hb.setAttribute('aria-label', isActive ? 'Close menu' : 'Open menu');
			hb.setAttribute('aria-expanded', String(isActive));
		});

		if (!isActive) {
			document.querySelectorAll('#nav ul li').forEach((el) => el.classList.remove('mod-show'));
			setTimeout(() => nav.classList.remove('mod-show'), 550);
		} else {
			setTimeout(() => {
				document.querySelectorAll('#nav ul li').forEach((el) => el.classList.add('mod-show'));
			}, 900);
		}
	});
}


/* ------------------------ Header hide on scroll ------------------------ */
function initHeaderHideOnScroll() {
	const headerMain = document.querySelector('.header-main');
	const banner = document.querySelector('.section-banner');
	if (!headerMain) return;

	const isHomePage = document.body.id === 'home';
	const scrollContainer = isHomePage ? document.querySelector('main') : window;
	if (!scrollContainer) return;

	function getScrollPosition() {
		return isHomePage
			? (scrollContainer.scrollTop || 0)
			: (window.scrollY || document.documentElement.scrollTop || 0);
	}

	function handleScroll() {
		const scroll = getScrollPosition();
		headerMain.classList.toggle('mod-hide', scroll > 100);

		// Only apply scroll-hide if banner isn’t permanently hidden
		if (banner && !banner.classList.contains('hide')) {
			banner.classList.toggle('mod-hide', scroll > 100);
		}
	}

	scrollContainer.addEventListener('scroll', handleScroll);
}

/* ------------------------ Nav dropdown toggles ------------------------ */
function initDropdownNav() {
	document.querySelectorAll('#nav ul li a.mod-dropdown').forEach((el) => {
		el.addEventListener('click', () => el.classList.toggle('mod-show'));
	});
}

/* ------------------------ Home snappy sections ------------------------ */
function initHomeSnappySections() {
	if (document.body.id === 'home' && window.matchMedia('(min-width: 1024px)').matches) {
		const container = document.querySelector('main');
		const sections = [...document.querySelectorAll('#home .section-full')];
		const pipContainer = document.getElementById('scroll-pips');

		if (container && sections.length && pipContainer) {
			let isLocked = false;
			let currentSection = 0;

			// Identify footer index and "last pip" index
			const footerIndex = sections.findIndex(s => s.tagName.toLowerCase() === 'footer');
			const lastPipIndex = footerIndex === -1 ? sections.length - 1 : Math.max(footerIndex - 1, 0);

			// Build pips (exclude footer)
			sections.forEach((_, idx) => {
				if (idx === footerIndex) return;
				const pip = document.createElement('div');
				pip.className = 'pip';
				pip.dataset.index = idx;
				pipContainer.appendChild(pip);
			});
			const pips = [...pipContainer.querySelectorAll('.pip')];

			function lockScroll(duration = 1000) {
				isLocked = true;
				setTimeout(() => { isLocked = false; }, duration);
			}

			function updateActivePip() {
				// If we're on the footer, display the last pip as active
				const displayIndex = (currentSection === footerIndex) ? lastPipIndex : currentSection;

				pips.forEach(pip => {
					const pipIndex = parseInt(pip.dataset.index, 10);
					pip.classList.toggle('active', pipIndex === displayIndex);
				});

				// Your white modifier logic can also use displayIndex if you want it tied to the first section only
				if (displayIndex === 0) {
					pipContainer.classList.add('mod-white');
				} else {
					pipContainer.classList.remove('mod-white');
				}
			}

			function scrollToSection(index) {
				if (index < 0 || index >= sections.length) return;
				sections[index].scrollIntoView({ behavior: 'smooth' });
				currentSection = index;
				updateActivePip(); // immediate UI update
				lockScroll();
			}

			// Wheel control (one section per gesture)
			container.addEventListener('wheel', (e) => {
				if (isLocked) { e.preventDefault(); return; }
			
				const dir = Math.sign(e.deltaY);
				if (dir === 0) return;
			
				// We will handle this gesture; stop native scrolling now
				e.preventDefault();
			
				// Lock immediately so multiple wheel events in the same gesture are ignored
				isLocked = true;
			
				let targetIndex;
				if (dir > 0) {
					// going down: next section (clamped)
					targetIndex = Math.min(currentSection + 1, sections.length - 1);
				} else {
					// going up: previous section (clamped)
					targetIndex = Math.max(currentSection - 1, 0);
				}
			
				// Special-case footer: if we're on footer, "up" should go to the last content section
				if (dir < 0 && typeof footerIndex === 'number' && currentSection === footerIndex && footerIndex > 0) {
					targetIndex = footerIndex - 1;
				}
			
				scrollToSection(targetIndex); // scrollToSection will keep the UI updated and start the timed unlock
			}, { passive: false });
			

			// Click-to-scroll pips
			pips.forEach(pip => {
				pip.addEventListener('click', () => {
					const index = parseInt(pip.dataset.index, 10);
					if (!isLocked) scrollToSection(index);
				});
			});

			// IntersectionObserver scoped to the scrolling container
			const io = new IntersectionObserver((entries) => {
				// Suppress IO noise during the smooth scroll lock
				if (isLocked) return;

				// Choose the most visible section
				let best = null;
				for (const entry of entries) {
					if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
				}
				if (!best) return;

				const idx = sections.indexOf(best.target);
				if (idx !== -1 && idx !== currentSection) {
					currentSection = idx;
					updateActivePip(); // footer maps to last pip
				}
			}, {
				root: container,
				threshold: [0, 0.25, 0.5, 0.75, 1],
			});

			sections.forEach(s => io.observe(s));

			// Initial state
			updateActivePip();
		}
	}
}


/* ------------------------ Scroll to hash ------------------------ */
function initScrollToHash() {
	const hash = window.location.hash;
	if (!hash) return;

	const target = document.querySelector(hash);
	if (!target) return;

	setTimeout(() => {
		const elementTop = target.getBoundingClientRect().top + window.scrollY;
		window.scrollTo({ top: elementTop - 20, behavior: 'smooth' });
	}, 500);
}

/* ------------------------ Lightbox / Carousel ------------------------ */
function initLightbox() {
	const gallery = document.getElementById('property-gallery');
	if (!gallery) return;

	const imgs = Array.from(gallery.querySelectorAll('img[data-index]'));
	if (!imgs.length) return;

	let current = 0;
	let lightbox, stageImg, counter, thumbs, prev, next, closeBtn, lastFocused;
	let startX = 0;

	const clampIndex = i => (i + imgs.length) % imgs.length;

	const preload = i => {
		[clampIndex(i - 1), clampIndex(i + 1)].forEach(idx => {
			const pre = new Image();
			pre.src = imgs[idx].dataset.full || imgs[idx].src;
		});
	};

	const build = () => {
		lightbox = document.createElement('div');
		lightbox.className = 'lightbox';
		lightbox.setAttribute('role', 'dialog');
		lightbox.setAttribute('aria-modal', 'true');
		lightbox.setAttribute('aria-label', 'Image gallery');

		lightbox.innerHTML = `
			<div class="wrap">
				<button class="close" aria-label="Close (Esc)"><span>CLOSE</span> ✕</button>
				<button class="arrow prev" aria-label="Previous image">❮</button>
				<button class="arrow next" aria-label="Next image">❯</button>

				<div class="stage">
					<img alt="">
				</div>

				<div class="thumbs" aria-label="Thumbnails" role="list"></div>
				<div class="counter" aria-live="polite"></div>
			</div>
		`;

		document.body.appendChild(lightbox);
		stageImg = lightbox.querySelector('.stage img');
		counter = lightbox.querySelector('.counter');
		thumbs = lightbox.querySelector('.thumbs');
		prev = lightbox.querySelector('.prev');
		next = lightbox.querySelector('.next');
		closeBtn = lightbox.querySelector('.close');

		// thumbnails
		const frag = document.createDocumentFragment();
		imgs.forEach((el, i) => {
			const btn = document.createElement('button');
			btn.className = 'thumb';
			btn.type = 'button';
			btn.setAttribute('role', 'listitem');
			btn.setAttribute('aria-label', `Go to image ${i + 1}`);
			btn.dataset.index = String(i);

			const t = document.createElement('img');
			t.src = el.src;
			t.alt = el.alt || '';
			t.loading = 'lazy';
			btn.appendChild(t);

			btn.addEventListener('click', () => show(i), { passive: true });
			frag.appendChild(btn);
		});
		thumbs.appendChild(frag);

		// events
		prev.addEventListener('click', () => show(current - 1));
		next.addEventListener('click', () => show(current + 1));
		closeBtn.addEventListener('click', close);
		lightbox.addEventListener('click', e => { if (e.target === lightbox) close(); });

		document.addEventListener('keydown', onKey);
		lightbox.addEventListener('keydown', trapTab);

		// swipe
		stageImg.addEventListener('pointerdown', e => { startX = e.clientX; });
		stageImg.addEventListener('pointerup', e => {
			const dx = e.clientX - startX;
			if (Math.abs(dx) > 40) (dx > 0 ? prev : next).click();
		});
	};

	const open = index => {
		if (!lightbox) build();
		lastFocused = document.activeElement;
		document.body.style.overflow = 'hidden';
		lightbox.classList.add('open');
		show(index);
		closeBtn.focus();
	};

	const close = () => {
		if (!lightbox) return;
		lightbox.classList.remove('open');
		document.body.style.overflow = '';
		document.removeEventListener('keydown', onKey);
		if (lastFocused && lastFocused.focus) lastFocused.focus();
	};

	const onKey = e => {
		if (e.key === 'Escape') return close();
		if (e.key === 'ArrowLeft') return show(current - 1);
		if (e.key === 'ArrowRight') return show(current + 1);
	};

	const trapTab = e => {
	if (e.key !== 'Tab') return;
		const focusables = lightbox.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
		if (!focusables.length) return;
		const first = focusables[0];
		const last = focusables[focusables.length - 1];
		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault(); last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault(); first.focus();
		}
	};

	const show = index => {
		current = clampIndex(index);
		const src = imgs[current].dataset.full || imgs[current].src;
		const alt = imgs[current].alt || '';

		stageImg.src = src;
		stageImg.alt = alt;

		counter.textContent = `${current + 1} / ${imgs.length}`;

		thumbs.querySelectorAll('.thumb').forEach((b, i) => {
			b.setAttribute('aria-current', i === current ? 'true' : 'false');
		});

		preload(current);
	};

	gallery.addEventListener('click', e => {
		const t = e.target;
		if (!(t instanceof HTMLImageElement)) return;
		const idx = Number(t.dataset.index || 0);
		open(idx);
	});
}

/* ------------------------ Checkboxes / Radio Buttons ------------------------ */
function initCheckboxesRadioButtons() {
	// Delegate change events for any current/future inputs
	document.addEventListener('change', function (e) {
		const el = e.target;
		if (!(el instanceof HTMLInputElement)) return;

		// CHECKBOXES: set or clear "mod-checked" on the changed one
		if (el.type === 'checkbox') {
			const label = el.closest('label');
			if (label) label.classList.toggle('mod-checked', el.checked); // matches your original behavior
			const wrap = el.closest('.sub-checkbox-wrap');
			if (wrap) wrap.classList.toggle('mod-checked', el.checked);
		}

		// RADIOS: clear "mod-checked" only within the nearest .sub-checkbox-parent, then set on the changed one
		if (el.type === 'radio') {
			const parent = el.closest('.sub-checkbox-parent') || document;
			parent.querySelectorAll('.mod-checked').forEach(node => node.classList.remove('mod-checked'));

			if (el.checked) {
				const label = el.closest('label');
				if (label) label.classList.add('mod-checked');
				const wrap = el.closest('.sub-checkbox-wrap');
				if (wrap) wrap.classList.add('mod-checked');
			}
		}
	});
}

/* ------------------------ Heat network form ------------------------ */
function initHeatNetworkForm() {
	const form = document.querySelector('#helpSub form.mod-heat-network');
	if (!form) return;

	// Show the sections that apply to the answers given so far
	const update = () => {
		const show = (selector, visible) => {
			form.querySelector(selector).style.display = visible ? 'block' : 'none';
		};

		show('.mod-requester', form.querySelector('input[name="who-for"]:checked')?.value === 'Someone else');
		show('.mod-requester-other', form.querySelector('select[name="requester-relationship"]').value === 'Other');
		show('.mod-nominated', form.querySelector('input[name="contact-preference"]:checked')?.value === 'Through my nominated contact');
	};

	form.addEventListener('change', update);

	// The form resets after a successful submit, values only clear once the event has finished
	form.addEventListener('reset', () => {
		setTimeout(() => {
			form.querySelectorAll('.mod-checked').forEach((node) => node.classList.remove('mod-checked'));
			update();
		}, 0);
	});
}

/* ------------------------ FAQs ------------------------ */
function initFaqs() {
	const faqs = document.getElementById('faqs');
	if (!faqs) return;

	const items = faqs.querySelectorAll('.list-faqs > li .item-faq');

	items.forEach((el) => {
		const trigger = el.firstElementChild;
		if (!trigger) return;

		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			const isOpen = el.classList.contains('mod-active');

			// close all
			items.forEach(i => i.classList.remove('mod-active'));

			// open clicked one if it wasn't already open (toggle behavior)
			if (!isOpen) el.classList.add('mod-active');
		});
	});
}

/* ------------------------ Residents/Landing AJAX forms ------------------------ */
/**
 * Generic jQuery-powered AJAX binder.
 * - Honors honeypot #Form_Email
 * - Supports FormData when form has file inputs (e.g., fault form)
 * - On success: resets form, toggles thank-you, scrolls back to form
 * - On error: injects HTML into .sub-errors and scrolls
 */
function initAjaxForms() {
	if (!(window.$ && $.ajax)) return;

	// Compute scroll target lazily per submit
	const getFormScrollTop = ($form) => {
		try {
			const $container = $('#helpSub');
			if ($container.length && $form.length) {
				return $form.offset().top - 70;
			}
		} catch (e) {}
		return 0;
	};

	if ($('.section-banner').length > 0) {
		document.querySelector('.section-banner .sub-close').addEventListener('click', (e) => {
			e.preventDefault();

			// If no validation errors
			$.ajax({
				method: "POST",
				url: "api/banner-cookie/",
			}).done(function (response) {
				$('.section-banner').addClass('hide').removeClass('show');
				$('.header-main').removeClass('mod-expand');
			});
		});
	}

	/**
	 * Bind a form to POST to a URL via AJAX.
	 * @param {string} selector jQuery selector for form(s)
	 * @param {string} url endpoint
	 */
	
	/**
	 * Generic AJAX binder
	 */
	const bindAjax = (selector, url) => {
		$(document).on('submit', selector, function (e) {
			e.preventDefault();

			const $form = $(this);

			// Honeypot
			if ($form.find('input#Form_Email').val()) return false;

			// reCAPTCHA v3
			if (window.grecaptcha) {
				grecaptcha.ready(function () {
					grecaptcha.execute('6LcRhcQrAAAAALZP-mkxTK8rDFTge8yROigYvRUF', { action: 'submit' })
						.then(function (token) {
							// Ensure hidden input
							let tokenField = $form.find('input[name="g-recaptcha-response"]');
							if (!tokenField.length) {
								$form.append('<input type="hidden" name="g-recaptcha-response">');
								tokenField = $form.find('input[name="g-recaptcha-response"]');
							}
							tokenField.val(token);

							// Then perform AJAX
							doAjax($form, url);
						});
				});
			} else {
				// Fallback: just submit
				doAjax($form, url);
			}
		});
	};

	/**
	 * Perform the actual AJAX
	 */
	function doAjax($form, url) {
		const hasFile = $form.find('input[type="file"]').length > 0;
		let ajaxOpts = {
			method: 'POST',
			url: url
		};

		if (hasFile) {
			const fd = new FormData($form[0]);
			ajaxOpts.data = fd;
			ajaxOpts.processData = false;
			ajaxOpts.contentType = false;
		} else {
			ajaxOpts.data = $form.serialize();
		}

		$.ajax(ajaxOpts)
			.done(function (response) {
				const $errors = $form.find('.sub-errors');
				const scrollTop = getFormScrollTop($form);

				if (response === 'success') {
					$form.find('.form-element').removeClass('mod-filled');
					$form.trigger('reset');
					$form.hide();
					$('#helpSub .sub-thanks').fadeIn();
					if ($errors.length) $errors.html('');
					if (scrollTop) $('html, body').animate({ scrollTop }, 1000, 'swing');

					setTimeout(function () {
						$form.fadeIn();
						$('#helpSub .sub-thanks').hide();
					}, 6000);
				} else {
					if ($errors.length) $errors.fadeIn().html(response);
					if (scrollTop) $('html, body').animate({ scrollTop }, 1000, 'swing');
				}
			})
			.fail(function (xhr) {
				const $errors = $form.find('.sub-errors');
				const scrollTop = getFormScrollTop($form);
				console.error('AJAX ERROR', {
					status: xhr.status,
					statusText: xhr.statusText,
					responseText: xhr.responseText
				});
				const txt = xhr.responseText || ('HTTP ' + xhr.status);
				if ($errors.length) $errors.show().html(txt);
				if (scrollTop) $('html, body').animate({ scrollTop }, 1000, 'swing');
			});
	}

		// Ajax contact form processing
		$('#landing form').submit(function (e) {
			e.preventDefault();
	
			// if honeypot field is filled in by spambot, do not submit
			if ($('input#Form_Email').val().length != 0) {
				return false;
			}
	
			$.ajax({
				method: 'POST',
				url: 'process/landing/',
				data: $(this).serialize()
			}).done(function (response) {
	
				// If no errors
				if (response == 'success') {
					// Reset form completely
					$('#landing form .form-element').removeClass('mod-filled');
					$('#landing form').trigger('reset');
					$('#landing .form-content').hide();
	
					// Show thank you message
					$('#landing .thanks').fadeIn();
	
					// Remove any errors that may still be there
					$('#landing form .sub-errors').html('');
	
					// Hide thank you message after 10 seconds and return to form
					setTimeout(function () {
						$('#landing .form-content').fadeIn();
						$('#landing .thanks').hide();
					}, 10000);
				}
				else {
					$('#landing form .sub-errors').fadeIn().html(response);
				}
			});
		});
	
		if ($('#landing').length) {
			$(window).scroll(function () {
				var limit = 300;
		
				if ($(this).scrollTop() >= limit) {
					$('.sub-fixed-form').addClass('mod-fixed');
				} else {
					$('.sub-fixed-form').removeClass('mod-fixed');
				}
			});
		
			// Identify any links that starts with a hash (#)
			$('.sub-fixed-bar-mobile a').on('click', function (e) {
				e.preventDefault();
		
				var link = $(this).attr('href').split('#').pop();
				var targetScroll = $('#' + link).offset().top;
		
				$('html, body').animate({ scrollTop: targetScroll }, 700, 'swing');
			});
		};


	// Residents sub forms
	bindAjax('#helpSub form.mod-fault-form', 'process/fault/'); // uses FormData for file
	bindAjax('#helpSub form.mod-claim-form', 'process/insuranceClaim/');
	bindAjax('#helpSub form.mod-key-form', 'process/keyRequest/');
	bindAjax('#helpSub form.mod-mor', 'process/mor/');
	bindAjax('#helpSub form.mod-address-update', 'process/updateDetails/');
	bindAjax('#helpSub form.mod-paperless', '/process/goPaperless/');
	bindAjax('#helpSub form.mod-paper-app', 'process/placesApp/');
	bindAjax('#helpSub form.mod-name-update', 'process/updateName/');
	bindAjax('#helpSub form.mod-direct-debit', 'process/directDebit/');
	bindAjax('#helpSub form.mod-alteration', 'process/licenceAlteration/');
	// Help-form file uploads: show filename feedback for any file input
	$(document).on('change', '#helpSub form input[type="file"]', function () {
		var fileInput = this;
		var $fileInput = $(fileInput);
		var $wrap = $fileInput.closest('.form-element');
		var $display = $wrap.find('.upload-file, #upload-file').first();
		var $note = $wrap.next('.sub-attached-note');

		if (!$note.length) {
			$note = $('<p class="sub-attached-note" hidden></p>');
			$wrap.after($note);
		}

		if (fileInput.files && fileInput.files.length > 0) {
			var name = fileInput.files[0].name;
			$display.val(name).addClass('mod-attached');
			$note.text('Attached: ' + name)
				.removeAttr('hidden')
				.addClass('mod-visible');
			// Clear any prior error display on this form
			$fileInput.closest('form').find('.sub-errors').hide().html('');
		} else {
			$display.val('').removeClass('mod-attached');
			$note.text('')
				.attr('hidden', 'hidden')
				.removeClass('mod-visible');
		}
	});

	bindAjax('#helpSub form.mod-pet-consent', 'process/petConsent/');
	bindAjax('#helpSub form.mod-sublet', 'process/licenceSublet/');
	bindAjax('#helpSub form.mod-compliment', 'process/compliment/');
	bindAjax('#helpSub form.mod-vulnerable', 'process/vulnerablePersons/');
	bindAjax('#helpSub form.mod-heat-network', 'process/heatNetworkVulnerablePersons/');
	bindAjax('#helpSub form.mod-building-fire-safety', 'process/buildingFireSafety/');
}


/* ------------------------ DOM Ready  ------------------------ */
document.addEventListener('DOMContentLoaded', () => {
	// Reveal body once DOM is ready (keeps existing UX intent)
	document.body.style.visibility = 'visible';

	AOS.init({
		once: true,
		duration: 700,
		easing: 'ease-out'
	});
	initSlick();
	initCookieButtons();
	initFormFieldEffects();
	initContactForm();
	initNavHamburger();
	initHeaderHideOnScroll();
	initDropdownNav();
	initHomeSnappySections();
	initScrollToHash();
	initLightbox();
	initCheckboxesRadioButtons();
	initHeatNetworkForm();
	initFaqs();
	initAjaxForms();
});
